import script from "./onboading.vue?vue&type=script&setup=true&lang=js"
export * from "./onboading.vue?vue&type=script&setup=true&lang=js"

import "./onboading.vue?vue&type=style&index=0&id=6474e159&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6474e159"]])

export default __exports__